import React from 'react';
import {
    Box, Typography, Step, Stepper, StepLabel,
    StepConnector, stepConnectorClasses, styled
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import TimelineIcon    from '@mui/icons-material/Timeline';
import TimerIcon       from '@mui/icons-material/Timer';
import ShutterSpeedIcon from '@mui/icons-material/ShutterSpeed';

const ColorlibConnector = styled(StepConnector)(({ theme }) => {
    const isDark = theme.palette.mode === 'dark';
    return {
        [`&.${stepConnectorClasses.alternativeLabel}`]: { top: 22 },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundImage: 'linear-gradient(95deg, #d29d5c 0%, #e3b578 50%, #c8904a 100%)',
            },
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundImage: 'linear-gradient(95deg, #d29d5c 0%, #d29d5c 100%)',
            },
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: 3, border: 0, borderRadius: 1,
            backgroundColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(10,16,32,0.1)',
        },
    };
});

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => {
    const isDark = theme.palette.mode === 'dark';
    return {
        backgroundColor: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(10,16,32,0.06)',
        zIndex: 1,
        color: isDark ? '#fff' : theme.palette.text.primary,
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : 'rgba(10,16,32,0.12)'}`,
        ...(ownerState.active && {
            backgroundImage: 'linear-gradient(136deg, #d29d5c 0%, #e3b578 100%)',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,0.2)',
            borderColor: '#d29d5c',
            color: '#fff',
        }),
    };
});

function ColorlibStepIcon(props) {
    const { active, className, icon } = props;
    const icons = { 1: <TimelineIcon />, 2: <TimerIcon />, 3: <ShutterSpeedIcon /> };
    return (
        <ColorlibStepIconRoot ownerState={{ active }} className={className}>
            {icons[String(icon)]}
        </ColorlibStepIconRoot>
    );
}

const VestingTimeline = () => {
    const theme  = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const steps = [
        { label: 'Allocation',    desc: 'Instant Confirmation' },
        { label: 'Linear Unlock', desc: 'Per-Second Streaming' },
        { label: 'Full Liquidity', desc: 'Day 90 Completion'  },
    ];

    return (
        <Box sx={{
            width: '100%', p: 3, borderRadius: 2,
            bgcolor: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(10,16,32,0.025)',
            border: `1px solid ${isDark ? 'rgba(255,255,255,0.06)' : theme.palette.divider}`,
        }}>
            <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 800, mb: 3, display: 'block', letterSpacing: '0.1em' }}>
                SYSTEMATIC VESTING SCHEDULE
            </Typography>

            <Stepper alternativeLabel activeStep={1} connector={<ColorlibConnector />}>
                {steps.map((step) => (
                    <Step key={step.label}>
                        <StepLabel StepIconComponent={ColorlibStepIcon}>
                            <Typography variant="body2" fontWeight={700} color="text.primary" sx={{ mt: 1 }}>{step.label}</Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>{step.desc}</Typography>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>

            <Box sx={{
                mt: 4, p: 2, borderRadius: 1,
                bgcolor: isDark ? 'rgba(210,157,92,0.05)' : 'rgba(200,144,74,0.04)',
                borderLeft: `3px solid ${theme.palette.primary.main}`,
            }}>
                <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.5, display: 'block' }}>
                    <strong>Streaming Protocol:</strong> Your EBONDS are not "cliffed." They unlock continuously every second for 90 days, allowing you to claim accumulated tokens at any moment.
                </Typography>
            </Box>
        </Box>
    );
};

export default VestingTimeline;
